const serviceData = [
  {
    icon: "ri-truck-line",
    title: "Free Shipping",
    subtitle: "Get Products,No Delivery Charges.",
    bg: "#fdefe6",
  },
  {
    icon: "ri-refresh-line",
    title: "Easy Returns",
    subtitle: "Return Products Easily.Never Disheart",
    bg: "#ceebe9",
  },
  {
    icon: "ri-secure-payment-line",
    title: "Secure Payment",
    subtitle: "Always Keep your Account Secure.",
    bg: "#e2f2b2",
  },
  {
    icon: "ri-exchange-dollar-line",
    title: " Back Guarantee",
    subtitle: "Money Back Gurrantee.Stay Tuned",
    bg: "#d6e5fb",
  },
];

export default serviceData;
